// frontend/src/utils/execution/executionValidator.js

import {
  evaluateExecutionRules,
  EXECUTION_DECISIONS,
} from './executionRules';

import { debugLog } from '../logging/debugLog';

export function validateExecution(context = {}) {
  const {
    intent,
    targetEntity,
    relationshipState,
    message,
    conversationState,
  } = context;

  const result = evaluateExecutionRules({
    intent,
    targetEntity,
    relationshipState,
    message,
    conversationState,
  });

  const decision = result?.decision || EXECUTION_DECISIONS.ALLOW;
  const reason = result?.reason || 'No execution rule reason provided';

  const executionDecision = {
    intent: intent?.type || intent?.intent || null,
    category: result?.category || null,
    operation: result?.operation || null,
    target: targetEntity?.name || null,
    decision,
    reason,
  };

  debugLog('🛡️ [ExecutionDecision]', executionDecision);

  return executionDecision;
}